import React from 'react'
import Paper from '@mui/material/Paper';
import InfoIcon from '@mui/icons-material/Info';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination } from '@mui/material';



const columns = [
    { id: 'Address', label: 'Address', maxWidth:10 },
    { id: 'CTag', label: 'CTag'},
    { id: 'DefaultConnections', label: 'Default Connections' },
];

const SheetTableLeft = ({ 
    page, 
    rowsPerPage, 
    selectedRowLeft,
    sheetMappingData, 
    handleChangePage, 
    handleChangeRowsPerPage, 
    handleSelectRowLeft
}) => {

    let existingConnection = JSON.parse(localStorage.getItem('Connections'));
    
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer className='TableVirtuoso' sx={{ maxHeight: "100vh" }}>
                <Table className='connectionTable' stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sheetMappingData?.data?.length > 0 ? sheetMappingData?.data.map((row,i) => {
                            return (
                                <TableRow role="checkbox" tabIndex={-1} key={i} 
                                    onClick={() => handleSelectRowLeft(i + 1, row)}
                                    className={selectedRowLeft === i + 1 ? 'activeRow' : existingConnection?.some(e => e.LParam === row?.Address?.toString()) ? 'connectedRow' : ''}
                                >
                                    {columns.map((column) => {
                                        const value = row[column.id];
                                        let selectedAddres = existingConnection?.find(e => e.LParam === row?.Address?.toString());
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {column?.format && typeof value === 'number'
                                                    ? column.format(value) 
                                                    : column.id === 'Address' ? 
                                                    ( 
                                                    <span>
                                                        {value} 
                                                        {selectedAddres?.RParam &&
                                                            <IconButton 
                                                                color="inherit" 
                                                                title={selectedAddres?.RParam}
                                                                size='small'
                                                            >
                                                                <InfoIcon />
                                                            </IconButton> 
                                                        }
                                                    </span>)
                                                    : value
                                                }
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            {sheetMappingData?.total > 0 ?
                <TablePagination
                    rowsPerPageOptions={[100, 200, 500,{label:'ALL',value: -1}]}
                    component="div"
                    count={sheetMappingData?.total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage} 
                />
                : <></>
            }
        </Paper> 
    )
}

export default SheetTableLeft